import React, { Component } from 'react';
import './Banner.css';

class Banner extends Component {

  render() {
    return (
      <div className='banner'>
        <h1>BATTLESHIP</h1>
      </div>
    )
  }
};

export default Banner;


